export function fillChildren(key, children, baseMenuItems) {
  const index = baseMenuItems.value.findIndex(i => i.id === key);
  if (index > -1) {
    baseMenuItems.value.splice(index, 1, {
      ...baseMenuItems.value[index],
      children
    });
  }
}
